const env = import.meta.env.VITE_ENV

export default function EnvironmentBadge() {
  if (env === 'production' || !env) return null

  const config = {
    staging: {
      label: 'You are viewing the staging environment',
      bg: 'bg-yellow-100',
      text: 'text-yellow-800',
      border: 'border-yellow-300',
    },
    preview: {
      label: 'You are viewing the preview environment',
      bg: 'bg-ae-info-bg',
      text: 'text-ae-aqua-700',
      border: 'border-ae-aqua-300',
    },
  }

  const { label, bg, text, border } = config[env] || config.preview

  // 6.2: Full-width banner above nav bar instead of inline badge
  return (
    <div className={`${bg} ${text} ${border} border-b text-xs font-medium text-center py-1 px-4`}>
      {label}
    </div>
  )
}
